import React from 'react'
import enregistement from '../../Assets/img/enregistrements.webp'
import suiviecommande from '../../Assets/img/suivie_de_commande.webp'
import statistique from '../../Assets/img/statistique.webp'
import codepromo from '../../Assets/img/codepromo.webp'

const SoftwareDetails = () => {
    return (
        <>
            <section className="capturelogiciel-section m-5">
                <div className="container ">
                    <h2 data-aos="fade-up">Efficacité. Sécurité. Rentabilité.</h2>
                    <p className="description">   L'application idéale pour simplifier la gestion de votre pressing. </p>
                    <div className="row capturelogiciel__text mb-5" data-aos="fade-up">
                        <div className="col-md-6 flex-column d-flex justify-content-center " >
                            <h3 >Enregistrement Commande</h3>
                            <p >Avec une interface simple et explicite, l'enregistrement des vêtements se fait juste en quelques étapes à la portée de tous. Pas besoin d'avoir de connaissance particulière en informatique. </p>
                            <p className="border p-3 rounded mt-5" >Lors de l'enregistrement, <span className='fw-bold'> le nom du client, son numéro de téléphone et les images des vêtements qu'il a déposés sont sauvegardés dans le système.</span> Une fois l'enregistrement validé avec succès, un message de confirmation est automatiquement envoyé au client via WhatsApp et/ou SMS. Ce message inclut l'identifiant de la commande, le montant total, ainsi que d'autres informations utiles.</p>
                        </div>
                        <div className="col-md-6" >
                            <img src={enregistement} alt="" className="img-fluid rounded mt-2" width={500} />
                        </div>
                    </div>
                    <hr />
                    <div className="row capturelogiciel__text mb-5 pb-5" data-aos="fade-up">
                        <div className="col-md-6" >
                            <img src={suiviecommande} className="img-fluid rounded " alt="" width={600} />
                        </div>
                        <div className="col-md-6 flex-column d-flex justify-content-center" data-aos-offset="300" >
                            <h3 > Suivi de commande</h3>
                            <p >Permettez à vos clients de suivre en temps réel l'état de leurs commandes (dépôt, traitement, retrait, livraison) directement depuis notre application de gestion de pressing.</p>
                            <ul className='mt-5' >
                                <li><span className='fw-bold'>En cours : </span>Notification confirmant la validation du dépôt des vêtements.</li>
                                <li><span className='fw-bold'>Terminée : </span>Notification informant le client qu'il peut se rendre à l'agence pour récupérer ses vêtements.</li>
                                <li><span className='fw-bold'>Livraison en cours : </span> Notification indiquant au client qu’un livreur est en route pour lui remettre ses vêtements à domicile.</li>
                                <li><span className='fw-bold'>Rétiré : </span> Notification confirmant que le retrait des vêtements a été effectué.</li>
                            </ul>

                        </div>

                    </div>
                    <hr />
                    <div className="row capturelogiciel__text mb-5 pb-5" data-aos="fade-up">
                        <div className="col-md-6 flex-column d-flex justify-content-center" >
                            <h3> Statistiques en temps réel</h3>
                            <p>Consultez les performances de votre pressing grâce à des statistiques détaillées disponibles en temps réel. Suivez les dépôts, les commandes traitées, et bien plus. <span className='fw-bold'>De plus, une copie de chaque dépôt peut vous être envoyée automatiquement par le système si nécessaire.</span> </p>
                        </div>
                        <div className="col-md-6" >
                            <img src={statistique} alt="" className="img-fluid rounded " width={600} />
                        </div>
                    </div>
                    <hr />
                    <div className="row capturelogiciel__text mb-5 pb-5" data-aos="fade-up">
                        <div className="col-md-6" >
                            <img src={codepromo} className="img-fluid rounded " alt="" width={600} />
                        </div>
                        <div className="col-md-6 flex-column d-flex justify-content-center" >
                            <h3> Marketing et promotions </h3>
                            <p>  <span className='fw-bold'>Boostez vos revenus grâce à des codes promo personnalisés.</span>  Vous pouvez facilement créer des offres attractives, comme 10 % de réduction pour les dépôts inférieurs à 1 500 F ou 20 % de réduction pour ceux dépassant 3 000 F. Attirez davantage de clients et fidélisez-les avec des promotions adaptées à votre stratégie.  </p>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default SoftwareDetails